// extracted by mini-css-extract-plugin
export default {"globalCenter":"LoadingIndicator_globalCenter__vXhSq","lds-ripple":"LoadingIndicator_lds-ripple__3Va3G"};